import sistemaBNCCService from "./SistemaBNCCService";
import alunosService from "./AlunosService";
import anosService from "./AnosService";
import authService from "./AuthService";
import caixasService from "./CaixasService";
import franquiasService from "./FranquiasService";
import matriculasService from "./MatriculasService";
import formasDePagamentoService from "./FormasDePagamentoService";
import parcelasService from "./ParcelasService";
import turmasService from "./TurmasService";
import turnosService from "./TurnosService";
import seriesService from "./SeriesService";
import cursosService from "./CursosService";
import cepService from "./CepService";
import disciplinasService from "./DisciplinasService";
import professoresService from "./ProfessoresService";
import usuariosService from "./UsuariosService";
import inepService from "./InepService";
import gestoesDeAulasService from "./GestoesDeAulasService";
import aulasService from "./AulasService";
import notasService from "./NotasService";
import relatoriosService from "./RelatoriosService";
import tiposDeEnsinosService from "./TiposDeEnsinosService";
import planosBimestraisService from "./PlanosBimestraisService";
import rolesService from "./RolesService";
import avisosService from "./AvisosService";
import imageService from "./ImageService";
import agendasService from "./AgendaService";
import notifiqService from "./NotifiqService";
import responsavelAlunoService from "./ResponsavelAlunoService";
import movimentacaoService from "./MovimentacaoService";
import sangriaService from "./SangriaService";
import categoriaService from "./CategoriaCircuitoService";
import circuitoService from "./CircuitoService";
import cicloService from "./CicloService";
import horariosService from "./HorariosService";
import calendarioLetivoService from "./CalendarioLetivoService";
import eventoCalendarioLetivoService from "./EventoCalendarioLetivoService";
import planosSemanaisService from "./planosSemanaisService";
import planosSemanaisInfantilService from "./planosSemanaisInfantilService";

// circuito de notas
import circuitoNotasService from "./CircuitoNotasService";
import etapasService from "./EtapasService";
import subEtapasService from "./SubEtapasService";
import autorizacoesService from "./AutorizacoesService";
import regrasService from "./RegrasService";
import historicoService from "./HistoricoService";

const $services = {
  alunosService,
  anosService,
  authService,
  caixasService,
  franquiasService,
  matriculasService,
  formasDePagamentoService,
  parcelasService,
  turmasService,
  turnosService,
  seriesService,
  cursosService,
  cepService,
  disciplinasService,
  professoresService,
  usuariosService,
  inepService,
  gestoesDeAulasService,
  aulasService,
  notasService,
  relatoriosService,
  sistemaBNCCService,
  tiposDeEnsinosService,
  planosBimestraisService,
  rolesService,
  avisosService,
  imageService,
  agendasService,
  notifiqService,
  responsavelAlunoService,
  movimentacaoService,
  sangriaService,
  categoriaService,
  circuitoService,
  cicloService,
  circuitoNotasService,
  etapasService,
  subEtapasService,
  autorizacoesService,
  regrasService,
  horariosService,
  calendarioLetivoService,
  eventoCalendarioLetivoService,
  planosSemanaisService,
  planosSemanaisInfantilService,
  historicoService,
};

export default $services;
